import api from "../axios";
import {
  type PaymentInfo,
  type EnrollPaymentMethodRequest,
  type EnrollPaymentMethodResponse,
  type Enrollment,
} from "../types";

export interface ServerPaymentMethod {
  payment_id: string;
  title: string;
  method: string;
  card: {
    first6: string;
    last4: string;
    card_type: string;
    expiry_month: string;
    expiry_year: string;
  };
}

export interface ServerPaymentResponse {
  data: ServerPaymentMethod[];
}

export const getSavedMethods = async () => {
  const response = await api.get<ServerPaymentResponse>(
    "/payments/saved-methods",
  );
  return response.data;
};

export const getAllMethods = async () => {
  const response = await api.get<ServerPaymentResponse>("/payments/methods");
  return response.data;
};

export const getPaymentInfo = async (paymentId: string) => {
  const response = await api.get<PaymentInfo>(`/payments/${paymentId}`);
  return response.data;
};

export const enrollPaymentMethod = async (data: EnrollPaymentMethodRequest) => {
  const response = await api.post<EnrollPaymentMethodResponse>(
    "/payments/methods/enrollments",
    data,
  );
  return response.data;
};

export const getEnrollmentStatus = async (enrollmentId: string) => {
  const response = await api.get<Enrollment>(
    `/payments/methods/enrollments/${enrollmentId}`,
  );
  return response.data;
};
